const permissions = {
  assetCatalog: 'AC001',
  assetAdd: 'AC002',
  assetEdit: 'AC003',
  assetDelete: 'AC004'
};

export default permissions;
